<template>
  <div id="headerNav">
    <!-- isShowTime -->
    <div class="messageTip" v-if="isShowTime" ref="scrollText">
      <div class="text_sss" :style="{left:scrollRight+'px'}">{{noteText}}</div>
    </div>
    <div class="head-left" >
      <img src="/static/favicon.ico" alt="logo" width="33" style="margin-top:-4px" />
      <div class="iten-text"  @click.stop="enter('isSetBooksShow')">
        <span class="top">{{accountInfoData}}</span>
        <span>{{accountInfoDataTime}} {{accountingSystem}}</span>
      </div>
      <div  class="elCardStyle">
        <span class="icon_container"  @click.stop="enter('isSetBooksShow')">
          <i class="el-icon-arrow-down" :style="{  transform: 'rotate(' + (isSetBooksShow ? '180' : '0') + 'deg)'}"></i>
        </span>
        <transition name="el-zoom-in-top">
          <set-books
            ref="booksList"
            v-show="isSetBooksShow"
            @JieSuo="JieSuo"
            @modify="modify"
            @ceratSetOfBooks="ceratSetOfBooks"
            :superTT="superTT"
            :allBooks="allBooks"
          ></set-books>
        </transition>
      </div>
      <div class="overduePrompt" v-if="preventMessage" @click.stop="reactivate">
        <span>
          {{preventMessage}}
          <i class="el-icon-right"></i>
        </span>
      </div>
    </div>
    <div class="head-right">
      <div class="head_right_left">
        <span style="margin-right: 24px;display: inline-block;">
          <span class="publicStyle flex_center" @click="video_c" style="display: flex;align-items: center;">
            <img :src="iconStyle.icon" alt class="video_img" ref="videoImg" />
            <span class="fs16">好账演示</span>
          </span>
        </span>
        <!-- 取消class phoneIcon  escalation-->
        <div v-if="projectReportRole.find(x => x.name == '项目上报')" class="publicStyle flex_center" @click.stop="projectEscalation">
          <img src="../../../static/img/escalation.png" class="left_icon"/>
          <span class="fs16">项目上报</span>
        </div>
        <!-- <span class="publicStyle" @click="a" v-if="!isPrivateNonProfit">
          <img src="static/icon/new_report.png" alt class="left_icon" />统计台
        </span>-->
        <span class="phoneIcon publicStyle flex_center" @click.stop="middlePhoneClick">
          <img src="static/icon/new_phone.png" alt class="left_icon" />
          <span class="fs16">移动端</span>
        </span>
        <span v-if="projectReportRole.find(x => x.permission == 'ac:show:periodIssues')" class="phoneIcon publicStyle flex_center" @click.stop="problemFeedback">
          <img src="../../../static/img/question.png" class="left_icon"/>
          <span class="fs16">账务问题</span>
        </span>
        <div style="display:inline">
          <el-popover ref="popover2" placement="bottom" width="100" trigger="click">
            <div solt="content" class="rot">
              <span @click="handlequestion">提交问题</span>
              <span @click="handlehistory">历史问题</span>
            </div>
          </el-popover>
          <span id="news" v-if="code">最新消息</span>

          <!-- <el-button v-popover:popover2 type="text">
            <img src="../../../static/img/question.png" style="margin-right:10px"/>问题反馈
          </el-button>-->
        </div>
      </div>
      <div class="head_right_center"></div>
      <div class="head_right_right">
        <span class="publicStyle active_header" @click.stop="helpCenterClick">
          <img src="static/icon/new_help.png" alt />
          <transition name="el-zoom-in-top">
            <user-help v-show="ishelpShow"></user-help>
          </transition>
        </span>
        <span class="centerIcon publicStyle active_s" @click="messageCenterClick">
          <img src="static/icon/new_message.png" alt />
        </span>
        <span class="publicStyle active_header" @click.stop="userCenterClick">
          <img src="static/icon/new_userCenter.png" alt />
          <transition name="el-zoom-in-top">
            <user-message v-show="isuserMessageShow" @closeDialog="closeDialog"></user-message>
          </transition>
        </span>
      </div>
    </div>
    <!-- 移动端扫码 -->
    <qr-code :isQrCodeShow.sync="isQrCodeShow"></qr-code>
    <!-- 好账演示视频 -->
    <el-dialog
      title="好账演示视频"
      :visible.sync="videoShow"
      width="1200px"
      class="default-dialog video_dialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <!-- <video :src="videoUrl" autobuffer autoloop loop controls width="100%" height="100%" id='video'></video> -->
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
    </el-dialog>
    <!-- 重新激活选择cdk弹窗 -->
    <cdk-select
      ref="cdkSelect"
      :dialog-visible.sync="cdkVisible"
      :loginName="cdkSelectLoginName"
      @hzUseCdkey="hzUseCdkey($event)"
      @view-tems="handleClickRead($event)"
    />
  </div>
</template>

<script>
import setBooks from "@/components/dialog/setBooks"
import userMessage from "@/components/dialog/userMessage"
import QrCode from "@/components/dialog/QrCode"
import { mapState, mapMutations } from "vuex"
import userHelp from "@/components/dialog/userHelp"
import cdkSelect from "@/components/dialog/CDKSelect"
export default {
  components: {
    setBooks,
    userMessage,
    userHelp,
    QrCode,
    cdkSelect
  },
  inject: {
    bookObj: {
      default: () => {}
    }
  },
  props: {
    code: false
  },
  data() {
    return {
      allBooks: [],
      change: false,
      iconStyle: {
        icon: "static/icon/video.png"
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "https://files.mankoo.cn/group1/M00/video/course/hzxs.mp4" //url地址
            // src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      videoShow: false, // 视频是否显示
      videoUrl:
        "https://outin-3aef3537b51411ea9b7000163e1c60dc.oss-cn-shanghai.aliyuncs.com/sv/23da888a-172dfb7883a/23da888a-172dfb7883a.mp4?Expires=1592902226&OSSAccessKeyId=LTAIVVfYx6D0HeL2&Signature=sEfkMRJdQvUe5I8ITKdUqU%2Be0%2FI%3D",
      timeer_s: null,
      noteText: "",
      isShowTime: false,
      scrollRight: null,
      isPrivateNonProfit: false, // 判断民办非
      isQrCodeShow: false, // 移动端弹框
      title: "",
      superTT: false,
      isSetBooksShow: false,
      isuserMessageShow: false, //
      ishelpShow: false,
      isDialogShow: false,
      userType_s: "",
      timeer_sss: null,
      timeer_img: null,

      // 重新激活选择cdk弹窗
      cdkVisible: false,
      // 是否存在主张套
      ishavePrimary: false,
      // 是否存在更多的cdkey
      hasMoreCdkey: "",
      // 项目上报的权限
      projectReportRole: [],
    }
  },
  watch: {
    isSetBooksShow(val) {
      if (val) {
        this.allBooks = this.bookObj.allBooks
      }
    }
  },
  created() {
    // clearInterval(this.timeer_img);
    //  this.timeer_img = setInterval(()=>{
    //   if(this.change) {
    //     this.iconStyle.icon = 'static/icon/video1.png'
    //   }else {
    //     this.iconStyle.icon = 'static/icon/video.png'
    //   }
    //   this.change = !this.change;
    // },300)
    this.getAccountInfo()
    this.haveCdkey()
    this.userType_s = this.$getSessionStorage("userType_s")

    this.isMBF()
    this.getButton(['examine:manageAccount','ac:show:periodIssues'],'projectReportRole')
  },
  mounted() {
    let _ = this
    document.body.addEventListener("click", _.bodyClick)
  },
  beforeDestory() {
    document.body.removeEventListener("click", this.bodyClick)
  },
  computed: {
    ...mapState(["accountInfo"]),
    accountInfoData() {
      return this.$store.state.accountInfo.accountInfoData.name
    },
    accountingSystem() {
      return this.$store.state.accountInfo.accountInfoData.accountingSystem
    },
    accountInfoDataTime() {
      return this.$util.formatDate.format(this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp, "yyyy年MM期")
    },
    // 是否提示过期
    overdueTip() {
      return this.$store.getters.superPreventOperation || this.$getSessionStorage("superPreventOperation")
    },
    preventMessage() {
      if (this.overdueTip) {
        this.cdkVisible = true
        return "账户已过期，请使用CDKEY重新激活"
      } else if (this.hasMoreCdkey) {
        return "您还有其他CDKEY未使用，立即使用"
      } else {
        return false
      }
    },
    cdkSelectLoginName() {
      return this.$getSessionStorage("userMssage_number")
    }
  },
  methods: {
    // 获取按钮权限
    getButton(arr, key) {
      let params = {
        permissions: arr.join(","),
      };
      try {
        this.$http.post("sys/menu/findPermissionMenu", params).then((res) => {
          if (res && res.data.code == 1) {
            if (res.data.data.length) {
              this[key] = res.data.data;
            }
          }
        });
      } catch (e) {}
    },
    // 打开存在问题
    problemFeedback() {
      this.$emit("problemFeedback")
    },
    // 打开项目上报
    projectEscalation() {
      this.$emit("projectEscalation")
    },
    // 为了在创建完账套之后调用刷新账套列表
    getBooks() {
      this.$refs.booksList.getBooks()
    },
    // 查询是否含有更多cdkey
    haveCdkey() {
      this.$http.post("/cdkeyContrller/haveCdkey", {}).then(res => {
        if (res.data.code === "1") {
          this.hasMoreCdkey = res.data.data
        }
      })
    },
    // 提示账套过期，点击重新激活
    reactivate() {
      this.cdkVisible = true
    },
    // 使用CDKEY
    hzUseCdkey(res) {
      this.$message.success(res.data.msg && res.data.msg)
      this.cdkVisible = false
      this.$store.dispatch("getAccountInfo").then(res => {
        console.log(res)
        this.getBooks()
      })
      this.haveCdkey()
      // 没有主账套就弹出创建账套
      if (this.ishavePrimary) {
        this.$emit("ceratSetOfBooks", "0")
      }
    },
    // 查看协议
    handleClickRead(type) {
      if (type === "1") {
        window.open("/static/servicePage/service.html")
      } else {
        window.open("/static/servicePage/privacy.html")
      }
    },
    // 关闭弹框视频暂停
    handleClose(done) {
      this.$refs.videoPlayer.player.pause()
      done()
    },
    // 视频点击
    video_c() {
      this.videoShow = true
    },
    // 获取播报
    getNote() {
      this.$http.post("sys/account/getNotices", {}).then(res => {
        if (res.data && res.data.code == 1) {
          if (res.data.data.length) {
            this.isShowTime = true
            this.noteText = res.data.data[0].msg
            this.$nextTick(() => {
              clearInterval(this.timeer_sss)
              this.textScroll()
            })
          } else {
            this.isShowTime = false
          }
        } else {
          this.isShowTime = false
        }
      })
    },
    //文字播报
    textScroll() {
      if (!this.isShowTime) return
      let container = document.getElementsByClassName("messageTip")[0]
      let content = document.getElementsByClassName("text_sss")[0]
      this.scrollRight = this.scrollRight ? this.scrollRight : 550
      this.timeer_sss = setInterval(() => {
        this.scrollRight -= 1
        if (this.scrollRight < -content.clientWidth) {
          this.scrollRight = 550
        }
      }, 20)
    },
    // 判断是否是民办非
    isMBF() {
      this.$store.dispatch("getIsPrivateNonProfit", {}).then(res => {
        this.isPrivateNonProfit = res
      })
    },

    // 跳转关闭用户中心
    closeDialog(data) {
      this.isuserMessageShow = false
    },
    // 点击空白关闭弹框
    bodyClick() {
      this.isuserMessageShow = false
      this.ishelpShow = false
      this.leave('isSetBooksShow')
    },
    // 用户中心点击
    userCenterClick() {
      this.isuserMessageShow = true
      this.ishelpShow = false
    },
    // 移动端点击
    middlePhoneClick() {
      this.ishelpShow = false
      this.isuserMessageShow = false
      this.isQrCodeShow = true
    },
    // 帮助中心点击
    helpCenterClick() {
      this.ishelpShow = true
      this.isuserMessageShow = false
    },
    // 消息中心点击
    messageCenterClick() {
      return this.$message.warning("您暂时没有消息哟")
    },
    a() {
      this.$router.push({ path: "./reportDesk" })
      this.$setSessionStorage(
        "nowYearPeriod",
        this.$util.formatDate.format(this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp, "yyyyMM")
      )
    },
    // 获取当前账套信息
    getAccountInfo() {
      this.$store.dispatch("getAccountInfo")
    },
    // 接收点击切换信息
    JieSuo(data) {
      this.$emit("JieSuo", data)
    },
    // 点击创建账套
    ceratSetOfBooks(bookId) {
      // 判断是否有主张套
      this.$http.post("/createAccountSet/havePrimary", {}).then(res => {
        if (res.data && res.data.code == 1) {
          const data = res.data.data
          this.ishavePrimary = true
          // 有主张套就弹出新建账套弹窗
          if (data.cdkeyList) {
            this.$emit("ceratSetOfBooks", bookId)
            return
          }
          // 反之则弹出授权cdk
          this.cdkVisible = true
        }
      })
    },
    // 接收点击修改信息
    modify(data) {
      this.$emit("modify", data)
    },
    enter(val) {
      this.superTT = !this.superTT
      this[val] = !this[val]
    },
    leave(val) {
      this.superTT = false
      this[val] = false
    },
    // 问题反馈
    handleProblemClick() {
      console.log(1)
    },

    // 提交问题
    handlequestion() {
      let _ = this
      var name = _.$getSessionStorage("userMssage_name")
      var phone = _.$getSessionStorage("userMssage_number")
      var submitterId = localStorage.getItem("accountId")
      let url = ""
      if (process.env.PATH_ENV === "prod") {
        url = "http://c.accountsir.com"
      } else {
        url = "http://192.168.1.9:9001"
      }
      open(url + "/submit?name=" + name + "&phone=" + phone + "&submitterId=" + submitterId + "&type=2")
      //  open(
      //   "http://192.168.1.249:8090/submit?name=" +
      //     name +
      //     "&phone=" +
      //     phone +
      //     "&submitterId=" +
      //     submitterId +
      //     "&type=2"
      // );
    },

    // 历史问题
    handlehistory() {
      var submitterId = localStorage.getItem("accountId")
      let url = ""
      if (process.env.PATH_ENV === "prod") {
        url = "http://c.accountsir.com"
      } else {
        url = "http://192.168.1.9:9001"
      }
      open(url + "/problemUser?submitterId=" + submitterId)
      //open("http://192.168.1.249:8090/problemUser?submitterId=" + submitterId);
    }
  }
}
</script>
<style lang="less">
.video_dialog {
  .el-dialog__body {
    padding: 0 !important;
    background: #000;
  }
}
</style>
<style lang="less" scoped>
#headerNav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  height: 60px;
  width: 100%;
  background-color: #269d7b;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  text-align: left;

  .messageTip {
    width: 548px;
    position: absolute;
    left: 40%;
    height: 40px;
    background: rgba(255, 0, 0, 0.5);
    color: #fff;
    border-radius: 2px;
    overflow: hidden;
    .text_sss {
      position: absolute;
      line-height: 40px;
      text-align: left;
      word-break: keep-all;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .reportDesk_header_get_in {
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    i {
      display: inline-block;
      font-size: 18px;
      margin-left: 5px;
    }
  }
  .head-left {
    display: flex;
    height: 60px;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    img {
      /*width: 37px;
        height: 37px;*/
    }
    .iten-text {
      min-width: 190px;
      span {
        display: block;
      }
      font-size: 12px;
      padding: 0 0 0 15px;
      .top {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .el-icon-arrow-down {
      font-size: 22px;
      display: inline-block;
      margin-top: 10px;
    }
    .elCardStyle {
      position: relative;
      cursor: pointer;
      height: 100%;
      padding: 0 20px 0 15px;
      .icon_container {
        display: inline-block;
        vertical-align: top;
        i {
          transition: all 0.3s;
        }
      }
      .setOfBooks_box {
        width: 355px;
        position: absolute;
        left: -170px;
        top: 60px;
        z-index: 9999;
      }
    }
    .overduePrompt {
      flex-shrink: 0;
      padding: 4px 10px;
      font-size: 14px;
      color: #ffffff;
      background: #ff6c22;
      line-height: 20px;
      border-radius: 14px;
      cursor: pointer;
    }
  }
  .head-right {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    .publicStyle {
      cursor: pointer;
      position: relative;
      height: 100%;
      img {
        display: inline-block;
        width: 26px;
      }
      .el-card {
        width: 300px;
        position: absolute;
        right: -25px;
        top: 40px;
        z-index: 9999;
      }
    }
    .head_right_center {
      width: 2px;
      height: 22px;
      background: #fff;
      border-radius: 1px;
    }
    .head_right_right {
      padding: 0 32px;
      .centerIcon {
        margin: 0 24px;
      }
      .active_header {
        &:hover {
          img {
            transform: scale(1.1);
          }
        }
      }
      .active_s {
        &:hover {
          img {
            animation: shake 0.25s linear alternate 1;
          }
        }
      }
      /*自定义动画*/
      @keyframes shake {
        0% {
          transform: rotate(0deg);
          transform-origin: 50% 30% 0;
        }
        33% {
          transform: rotate(-20deg);
          transform-origin: 50% 30% 0;
        }
        66% {
          transform: rotate(20deg);
          transform-origin: 50% 30% 0;
        }
        100% {
          transform: rotate(0deg);
          transform-origin: 50% 30% 0;
        }
      }
    }
    .head_right_left {
      padding: 0 32px;
      display: flex;
      align-items: center;
      .phoneIcon {
        margin-left: 24px;
      }
      .escalation {
        padding: 5px 10px;
        background-color: #20BD90;
        border-radius: 4px;
      }
      .video_img {
        margin-right: 10px;
        display: inline-block;
        width: 26px;
      }
      .left_icon {
        margin-bottom: 1px;
        margin-right: 7px;
        width: 26px !important;
      }
      .el-button {
        margin-left: 20px;
        color: #fff;
      }
      .problem {
        position: relative;
      }
      #news {
        position: absolute;
        top: 0px;
        right: 235px;
        background: #ff4b62;
        color: #fff;
        padding: 0 2px;
      }
    }
    /*.first_child {
        margin-right: .5rem;
      }
      .elCardStyle1 {
        height: 60px;
        position: relative;
        i{font-size: 25px; line-height: 60px;cursor:pointer}
        .el-card {
          width: 300px;
          position: absolute;
          right: -20px;
          top: 60px;
          z-index: 9999;
        }
      }*/
  }
}
.el-popover {
}
.rot {
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    width: 100%;
    text-align: center;
    cursor: pointer;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/HeaderNav.vue